<!--===============================
=            DATATABLE            =
================================-->
<template>
  <!-- data table -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Tables Advanced</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">
            Playground Table
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="desserts"
                :single-select="singleSelect"
                item-key="name"
                show-select
                class="elevation-1 grey--text"
              >
                <template v-slot:top>
                  <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
                </template>
              </v-data-table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <!-- data table -->
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">
            Search
            <div class="textt">
              The data table exposes a search prop that allows you to filter
              your data.
            </div>
          </div>
          <div slot="card-body">
            <div>
              <v-card class="elevation-0 transparent grey--text">
                <v-card-title>
                  Nutrition
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="desserts" :search="search"></v-data-table>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <!-- data table -->
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">Remove default header and footer</div>
          <div slot="card-body">
            <div>
              <v-data-table
                :headers="headers"
                :items="desserts"
                hide-default-header
                hide-default-footer
                class="elevation-1 grey--text"
              ></v-data-table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <!-- data table -->
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">Loading state</div>
          <div slot="card-body">
            <div>
              <v-data-table
                item-key="name"
                class="elevation-1 grey--text"
                loading
                loading-text="Loading... Please wait"
              ></v-data-table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <div>
              <v-data-table
                dense
                :headers="headers"
                :items="desserts"
                item-key="name"
                class="elevation-1 grey--text"
              ></v-data-table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">Footer props</div>
          <div slot="card-body">
            <div>
              <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="5"
                item-key="name"
                class="elevation-1 grey--text"
                :footer-props="{
                  showFirstLastPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus'
                }"
              ></v-data-table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card>
          <div slot="card-header">Filterable columns</div>
          <div slot="card-body">
            <v-card class="elevation-0 transparent pa-5 grey--text">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="desserts" :search="search"></v-data-table>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  mounted() {
    $(document).ready(function() {
      $("#example").DataTable();
    });
  },
  data() {
    return {
      singleSelect: false,
      selected: [],
      search: "",
      headers: [
        {
          text: "Dessert (100g serving)",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Calories",
          value: "calories"
        },
        {
          text: "Fat (g)",
          value: "fat"
        },
        {
          text: "Carbs (g)",
          value: "carbs"
        },
        {
          text: "Protein (g)",
          value: "protein"
        },
        {
          text: "Iron (%)",
          value: "iron"
        }
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%"
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%"
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%"
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: "8%"
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: "16%"
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%"
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%"
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: "45%"
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: "22%"
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%"
        }
      ]
    };
  }
};
</script>

<!--====  End of DATATABLE  ====-->
